import React from 'react';

export function SearchFile () {
  return (
    <svg
      width="92"
      height="99"
      viewBox="0 0 92 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="40.4597"
        y="0.388916"
        width="51.1339"
        height="63.8889"
        rx="2"
        fill="#B4DCD9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M87.4477 64.2779H42.4597C41.3551 64.2779 40.4597 63.3825 40.4597 62.2779V4.55566H84.4477C86.1045 4.55566 87.4477 5.89881 87.4477 7.55566V64.2779Z"
        fill="#96C6C2"
      />
      <rect
        x="40.4597"
        y="0.388916"
        width="51.1339"
        height="63.8889"
        rx="2"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <rect
        x="32.1677"
        y="7.3335"
        width="52.5159"
        height="66.6667"
        rx="2"
        fill="#B4DCD9"
      />
      <rect
        x="32.1677"
        y="7.3335"
        width="52.5159"
        height="66.6667"
        rx="2"
        fill="#B4DCD9"
      />
      <path
        d="M67.2683 11.5H32.1677V74H80.5377V24.8255C80.5377 24.2968 80.3283 23.7896 79.9554 23.4148L68.6861 12.0893C68.3107 11.7121 67.8005 11.5 67.2683 11.5Z"
        fill="#96C6C2"
      />
      <rect
        x="32.1677"
        y="7.3335"
        width="52.5159"
        height="66.6667"
        rx="2"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M22.4939 16.2778C22.4939 15.1733 23.3893 14.2778 24.4939 14.2778H66.3022C66.5683 14.2778 66.8234 14.3839 67.011 14.5725L77.4827 25.0964C77.6692 25.2837 77.7738 25.5373 77.7738 25.8017V81.7223C77.7738 82.8268 76.8784 83.7223 75.7738 83.7223H24.4939C23.3893 83.7223 22.4939 82.8268 22.4939 81.7223V16.2778Z"
        fill="#CFEDEB"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.8447 81.2594C25.5184 83.0355 28.723 84.0695 32.1678 84.0695C41.5177 84.0695 49.0973 76.4521 49.0973 67.0556C49.0973 57.6591 41.5177 50.0417 32.1678 50.0417C28.723 50.0417 25.5184 51.0758 22.8447 52.8519V57.2787C25.2653 54.9468 28.55 53.514 32.1678 53.514C39.6096 53.514 45.6423 59.5768 45.6423 67.0556C45.6423 74.5345 39.6096 80.5973 32.1678 80.5973C28.55 80.5973 25.2653 79.1644 22.8447 76.8326V81.2594Z"
        fill="#AEDDD9"
      />
      <path
        d="M66.7178 14.2778V24.3889C66.7178 24.9412 67.1655 25.3889 67.7178 25.3889H77.7738"
        stroke="#4AA49D"
        stroke-width="0.5"
        stroke-linejoin="round"
      />
      <ellipse
        cx="32.168"
        cy="33.7223"
        rx="4.146"
        ry="4.16667"
        fill="#B5DBD8"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.1193 32.1584C33.9788 32.0172 33.7502 32.0172 33.6097 32.1584L33.0682 32.7026L31.581 34.1973L30.8564 33.4691C30.7159 33.3279 30.4875 33.3279 30.3471 33.4691C30.2076 33.6092 30.2076 33.8357 30.347 33.9758L31.4446 35.0791C31.5198 35.1547 31.6421 35.1547 31.7173 35.0792L34.1193 32.6655C34.2589 32.5253 34.2589 32.2987 34.1193 32.1584Z"
        fill="#4AA49D"
      />
      <ellipse
        cx="32.168"
        cy="46.2223"
        rx="4.146"
        ry="4.16667"
        fill="#B5DBD8"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.1193 44.6584C33.9788 44.5172 33.7502 44.5172 33.6097 44.6584L33.0682 45.2026L31.581 46.6973L30.8564 45.9691C30.7159 45.8279 30.4875 45.8279 30.3471 45.9691C30.2076 46.1092 30.2076 46.3357 30.347 46.4758L31.4446 47.5791C31.5198 47.6547 31.6421 47.6547 31.7173 47.5792L34.1193 45.1655C34.2589 45.0253 34.2589 44.7987 34.1193 44.6584Z"
        fill="#4AA49D"
      />
      <ellipse
        cx="32.168"
        cy="58.7223"
        rx="4.146"
        ry="4.16667"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <ellipse
        cx="32.168"
        cy="71.2223"
        rx="4.146"
        ry="4.16667"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <rect
        x="40.46"
        y="32.3335"
        width="31.786"
        height="2.77778"
        rx="1.38889"
        fill="#6EB7B1"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <rect
        x="40.46"
        y="44.8335"
        width="31.786"
        height="2.77778"
        rx="1.38889"
        fill="#6EB7B1"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <rect
        x="40.46"
        y="57.3335"
        width="31.786"
        height="2.77778"
        rx="1.38889"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <rect
        x="40.46"
        y="69.8335"
        width="31.786"
        height="2.77778"
        rx="1.38889"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M28.022 21.2224C28.022 20.4553 28.6438 19.8335 29.4109 19.8335H66.7179V22.6113H29.4109C28.6438 22.6113 28.022 21.9894 28.022 21.2224Z"
        fill="#6EB7B1"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M1.3314 93.0018C0.065218 94.2746 0.065218 96.3383 1.3314 97.6112C2.59758 98.884 4.65047 98.884 5.91666 97.6112L19.7297 83.7293L15.1444 79.1199L1.3314 93.0018Z"
        fill="#CFEDEB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.1677 87.8888C20.7189 87.8888 11.4377 78.5614 11.4377 67.0555C11.4377 55.5496 20.7189 46.2222 32.1677 46.2222C43.6166 46.2222 52.8977 55.5496 52.8977 67.0555C52.8977 78.5614 43.6166 87.8888 32.1677 87.8888ZM32.1677 83.7222C23.0086 83.7222 15.5837 76.2602 15.5837 67.0555C15.5837 57.8508 23.0086 50.3888 32.1677 50.3888C41.3268 50.3888 48.7517 57.8508 48.7517 67.0555C48.7517 76.2602 41.3268 83.7222 32.1677 83.7222Z"
        fill="#B4DCD9"
      />
      <path
        d="M11.6877 67.0555C11.6877 78.4245 20.8581 87.6388 32.1677 87.6388V88.1388C20.5796 88.1388 11.1877 78.6983 11.1877 67.0555H11.6877ZM32.1677 46.4722C20.8581 46.4722 11.6877 55.6865 11.6877 67.0555H11.1877C11.1877 55.4127 20.5796 45.9722 32.1677 45.9722V46.4722ZM52.6477 67.0555C52.6477 55.6865 43.4773 46.4722 32.1677 46.4722V45.9722C43.7558 45.9722 53.1477 55.4127 53.1477 67.0555H52.6477ZM32.1677 87.6388C43.4773 87.6388 52.6477 78.4245 52.6477 67.0555H53.1477C53.1477 78.6983 43.7558 88.1388 32.1677 88.1388V87.6388ZM15.8337 67.0555C15.8337 76.1234 23.1479 83.4722 32.1677 83.4722V83.9722C22.8694 83.9722 15.3337 76.3971 15.3337 67.0555H15.8337ZM32.1677 50.6388C23.1479 50.6388 15.8337 57.9877 15.8337 67.0555H15.3337C15.3337 57.7139 22.8694 50.1388 32.1677 50.1388V50.6388ZM48.5017 67.0555C48.5017 57.9877 41.1876 50.6388 32.1677 50.6388V50.1388C41.4661 50.1388 49.0017 57.7139 49.0017 67.0555H48.5017ZM32.1677 83.4722C41.1876 83.4722 48.5017 76.1234 48.5017 67.0555H49.0017C49.0017 76.3971 41.4661 83.9722 32.1677 83.9722V83.4722Z"
        fill="#4AA49D"
      />
      <path
        d="M15.1444 79.1199L1.3314 93.0018C0.065218 94.2746 0.065218 96.3383 1.3314 97.6112C2.59758 98.884 4.65047 98.884 5.91666 97.6112L19.7297 83.7293"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
    </svg>
  );
}
